module.exports = __webpack_public_path__ + "static/media/gal-5.4114ded4.jpeg";